import React from 'react';
import __ from 'lodash';

class DropdownMapel extends React.Component{
    render(){
        if(this.props.mapel != null){
            return (
                this.props.mapel.map((val) =>
                    <option key={val.idMataPelajaran} value={val.idMataPelajaran}>{val.namaMataPelajaran}</option>
                )            
            )
        }
    }
}

export default DropdownMapel;